import { useSelector } from 'react-redux';
import { currentDialogSelector } from './store/currentDialogSelectors';

export const useDialog = () => {
  return useSelector(currentDialogSelector);
};
